var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_35_125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_35_125",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_35_125",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_35_125",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAM1BMVEVHcEzn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+exRWCXAAAAEHRSTlMAYCCg8BAwgMBAcNDgULCQdMnWCAAAAAlwSFlzAAALEgAACxIB0t1+/AAABCZJREFUaIHlWtm25CAIzK5m//+vnZNNQcCg6fs09dYdQ0UQKE0qCcNijLFatMaMrhFM8RiM3UvQrXXPGiTox7mI4cbqiEWC3nTkvkzMNbGK8Z3igB2I4YBhIuMLsRHbD+qfTOPCJCy1loz8go512W859r1j4v9rjn3fl3eOqTWLU6M2lkQ09lgdXZ9HIXApuDbi6VD+D/iiVWQtiziVLRjUo0LSjdz9WpoVsQBTBsWiwFEQyPOdN9bAv1dlHZUxQJetzzC4slrx3kIWRycyfZjH4Ny9Zh2dyiatuSy4c/Hc9XcELFdUwORIjqpRYxOgs54FeeGXdR4a/6SXM0DizRUOe2kOIpdfqQGsHh4MiVg+Eeiey0qDWMEvpjZrscckVWiyKwpJOQcw+ZCEBTbDkvLuLWfW0y+dXQ2OHwjB3d6Bh2DIDDGKsODSt3ct4AkmfbUKmeFAyJJJUnOKDygsnyf+L8uSJBaw4ygOTP6m5RwyByMtMBxIWHlxoN+I8YCgsFxdQxOGJSHGbzRpySfV1CySgQiEmIV3QQ7JKwdsf4UkvUa6sh7LIMHxmIw77PXO4P+5PNaTIInRQuc7tBljBI6aBOoxkAI3DUgeJixqEvC0jIrp4WVyVUsCBAGvYlINT0sSrtEHvTDJT6EkCaV15tZohXr7HkdFSRJKllyggyiNF5iSxPuCS4MHszRIRxK8JU8ETqWIxHf/jlgG6IGtAhI/iiwcBG9gFG5PkrTC3dKzGOH/JIkNg1LwXm3/kMSXhWh5/bckqTQBerQo8NKyidAKw3Qk/hEnYhjC15VowjqS0E1o2wsYpFHKAunLeMpf3ltzdEFJ4mV8YlMcqmhcfJQkocBKjRE8CFmD2vYb2p6000P7qTKSMI4/UYRKg1RRLQnQqCzLAq6TsKl1FxSQtODDww3qT71MhZLX4kRAOpVRAXoSfG64+hXU10gKMyo1R9XHJ6B2M8Zs8ZsProTmbILoWS4FDVfudu6dhRcaeRvT1N53ZxdWAUn6bUTHxaOApGrkV1yWJGGahMtpPxn+SGKWpiGSpPVCTY8MrBCNCytLkniqE82IcvztlQF8evVR1InBjeZ4b5ly7Y3wPEPWoVoOQEFCLUFcKCVA7SzsL6SsKgM66ARHtml9lYeoZ4KqkV7EWQAHls2vjtFjgIlc/gHJzNbsEkyxTdDIWblQAFi4r5wF64s/HssGbKdPs2l/zIJa9lN80BHgdxbEEbomFFD7/DEu6LAPaj5cxs2Xt2fYFKzsDW6wr185SGgi1YF3A7G86rZ8p/V19F6CxNfsMbpTx6nR0s5Js+73L/0pxx98vsBwRAv5M6RMcCkRlwnmGPlZH7KIy0P6u4GFF3G503hRS9W3b6J27RcWJKdy0G3arx/6ui2aj90yVULvju/h9BBVZVVV/wB60Q9C+NCWAwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite81);
export default __webpack_public_path__ + "static/media/instagram_white-8 1.6a64f684a9c779e5555ab15ce64edfcc.svg";
export { ForwardRef as ReactComponent };